import clsx from "clsx";
import React, {FunctionComponent} from "react";
import PhoneInput, {Country, isSupportedCountry} from "react-phone-number-input";
import "react-phone-number-input/style.css";
import {PropsWithOverwrite} from "../../../utils/input";
import {InputTextProps} from "./InputText";

export type InputPhoneCountry = Country & {};
export enum InputPhoneLocale {
    FRENCH = "fr",
    ENGLISH = "en"
}

type InputPhoneProps = PropsWithOverwrite<InputTextProps, {
    onCountryChange?: (value?: InputPhoneCountry) => void;
    locale?: InputPhoneLocale;
    country?: InputPhoneCountry;
}>;

const InputPhone: FunctionComponent<InputPhoneProps> = ({onCountryChange, locale, country, small, ...inputAttr}) => {
    if (!locale) locale = InputPhoneLocale.ENGLISH;
    if (!country || isSupportedCountry(country)) country = "FR";

    return (
        <PhoneInput
            onCountryChange={onCountryChange}
            labels={require(`react-phone-number-input/locale/${locale}.json`)}
            defaultCountry={country}
            addInternationalOption={false}
            className={clsx("input-phone", {"input--small": small})}
            {...inputAttr}
        />
    );
};

export default InputPhone;
